import "./EnergyInsight.css";

// 큐브 카드 · 그룹 합계가 같이 쓰는 숫자 타일. 값이 없으면 "–".
export const formatWatt = (value) => {
  if (value === null || value === undefined || value === "") return "–";
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "–";
  return Math.round(parsed).toLocaleString();
};

export function KpiTile({ label, value, unit, color }) {
  return (
    <div className="ei-kpi">
      <div className="ei-kpi-label">
        <i style={{ backgroundColor: color }} />
        {label}
      </div>
      <div className="ei-kpi-value">
        {formatWatt(value)}
        <small>{unit}</small>
      </div>
    </div>
  );
}
